<template>
  <UiDialog
    class="media-gallery-fullscreen"
    :name="props.name"
    dialog-type="fullscreen"
  >
    <div class="media-gallery-fullscreen__container">
      <UiMediaGalleryThumbs
        v-if="galleryOptions.fullscreenOptions.thumbs"
        :name="props.name"
        class="media-gallery-fullscreen__thumbs"
        :thumbs-direction="galleryOptions.fullscreenOptions.thumbsDirection"
        :thumbs-trigger="galleryOptions.fullscreenOptions.thumbsTrigger"
      >
        <template #thumbs-prev-icon>
          <slot name="thumbs-prev-icon" />
        </template>

        <template #thumbs-next-icon>
          <slot name="thumbs-next-icon" />
        </template>
      </UiMediaGalleryThumbs>

      <UiMediaGalleryFullscreenMain
        :name="props.name"
        class="media-gallery-fullscreen__main"
      />

      <div class="media-gallery-fullscreen__controls">
        <UiMediaGalleryXofY
          v-if="galleryOptions.fullscreenOptions.XofY"
          :name="props.name"
          class="media-gallery-fullscreen__x-of-y"
        >
          <template #divider>
            van
          </template>
        </UiMediaGalleryXofY>

        <UiMediaGalleryNavigation
          v-if="galleryOptions.fullscreenOptions.navigation"
          :name="props.name"
          class="media-gallery-fullscreen__navigation"
        >
          <template #gallery-prev-icon>
            <slot name="gallery-prev-icon" />
          </template>

          <template #gallery-next-icon>
            <slot name="gallery-next-icon" />
          </template>
        </UiMediaGalleryNavigation>

        <UiMediaGalleryDots
          v-if="galleryOptions.fullscreenOptions.dots"
          :name="props.name"
          class="media-gallery__dots"
        />
      </div>
    </div>
  </UiDialog>
</template>

<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryOptions } = useUiMediaGallery(props.name)
</script>

<style>
@import url("~layers/app/components/Ui/MediaGallery/Fullscreen.css");
</style>
